export default function SvgArrowRight({id = 'svg-arrow-right', ...rest}) {
    return (
        <svg {...rest} viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.7001 0.10641C14.079 -0.167222 13.3544 0.10641 13.0697 0.703425C12.785 1.30044 13.0697 1.99696 13.6908 2.27059C14.3119 2.54422 15.0366 2.27059 15.3212 1.67357C15.6059 1.07656 15.3212 0.380041 14.7001 0.10641Z"
                fill="currentColor"/>
            <path
                d="M23.2143 8.21582H23.1884L0 8.21582L0 10.579L20.7298 10.579L12.6812 18.3402L14.4151 20.0069L24.9482 9.88249L23.2143 8.21582Z"
                fill="currentColor"/>
            <path opacity="0.6" d="M13.2764 1.97233L15.0103 0.305664L25 9.88278L23.2401 11.5494L13.2764 1.97233Z"
                  fill={`url(#paint0_linear_963_547_right_${id})`}/>
            <defs>
                <linearGradient id={`paint0_linear_963_547_right_${id}`} x1="19.1294" y1="0.293873" x2="19.1294"
                                y2="11.5599" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0158937" stopColor="currentColor"/>
                    <stop offset="1" stopColor="currentColor" stopOpacity="0"/>
                </linearGradient>
            </defs>
        </svg>

    )
}